module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-home"
  }, [_c('div', {
    staticClass: "hero-home__bg",
    style: ({
      backgroundImage: 'url(' + _vm.props.background + ')'
    })
  }, [_c('video', {
    ref: "hero",
    attrs: {
      "src": _vm.props.video,
      "loop": "loop",
      "muted": "muted",
      "playsinline": "playsinline",
      "autoplay": "autoplay"
    },
    domProps: {
      "muted": true
    }
  }), _c('div', {
    staticClass: "hero-home__trigger"
  }, [_c('VueTrigger', {
    attrs: {
      "function1": _vm.onScrollInNav,
      "function2": _vm.onScrollOutNav
    }
  })], 1), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-home__icon"
  }, [_c('span'), _c('span')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53e43650","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/hero/hero-home/hero-home.pug
// module id = 650
// module chunks = 1